import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { dirhamPrice, DirhamPriceManipulationViewModel } from "./dirhamPriceManipulation-viewModel"

export class DirhamPriceManipulationView extends View<DirhamPriceManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-79C09F9A-7738-4141-AB31-A481EE9066B7"
    }
    loadHtml(): string {
        let element = require('./dirhamPriceManipulation.html').default;
        let style = require('./dirhamPriceManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set dirhamPrice(v: ObservableArray<dirhamPrice>) { this._dirhamPrice = v; } public get dirhamPrice(): ObservableArray<dirhamPrice> { return this._dirhamPrice;} private _dirhamPrice: ObservableArray<dirhamPrice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    
    requestDirhamPriceCreation(){
        this.dataContext.requestDirhamPriceCreation();
    }
        
    import(){
        this.dataContext.import();
    }
            
    export(){
        this.dataContext.export();
    }
    
    close(){
        this.dataContext.closePopup();
    }
}
